import GarmentCare from "./GarmentCare";

export default GarmentCare;
